import { Tooltip, Modal, Tab } from "./_bootstrap";

import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./_category";

import { initSwipers } from "./features/swiper";

const lazyModules = [
  {
    selector: ".js-product-gallery",
    loader: () => import("./features/product"),
  },
  {
    selector: "hr[data-read-more]",
    loader: () => import("./features/read-more"),
  },
];

document.addEventListener("DOMContentLoaded", () => {
  initSwipers();

  lazyModules.forEach(({ selector, loader }) => {
    const containers = document.querySelectorAll(selector);

    if (containers.length) {
      loader().then(({ default: init }) => {
        containers.forEach((container) => init(container));
      });
    }
  });
});

$(document).ready(function () {
  if (typeof lozad !== "undefined") {
    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();
    $(document).ajaxStop(function () {
      observer.observe();
    });
  }

  // Highlight any found errors
  $(".text-danger").each(function () {
    var element = $(this).parent().parent();

    if (element.hasClass("form-group")) {
      element.addClass("has-error");
    }
  });

  document
    .querySelectorAll('[data-toggle="tooltip"]')
    .forEach((tooltipElement) => new Tooltip(tooltipElement));

  // Makes tooltips work on ajax generated content
  $(document).ajaxStop(function () {
    document
      .querySelectorAll('[data-toggle="tooltip"]')
      .forEach((tooltipElement) => new Tooltip(tooltipElement));
  });

  $(document)
    .on("click", '[data-action="fastOrder"]', loadFastOrderForm)
    .on("click", '[data-action="showCart"]', initCart)
    .on("click", '[data-action="toCart"]', function () {
      const $this = $(this),
        productId = $this.data("id");
      let $quantity = $this
        .closest(".product-card")
        .find('[name="quantity"]')
        .val();
      $quantity = $quantity ? parseInt($quantity) : 1;
      if (productId && $quantity > 0) {
        cart.add(productId, $quantity);
      }
    })
    .on("click", '[data-action="showLoginForm"]', function (e) {
      e.preventDefault();
      openLoginForm();
    })
    .on("click", '[data-action="showMobileMenu"]', function (e) {
      e.preventDefault();
      openMobileMenu();
    })
    .on("click", '[data-action="showMobileCatalog"]', function (e) {
      e.preventDefault();
      openMobileCatalog();
    })
    .on("click", '[data-action="showSerchForm"]', function () {
      $("body").toggleClass("showSerach");
    })
    .on("click", function (e) {
      if (
        !$(e.target).closest(".header__serach").length &&
        $(e.target).closest('[data-action="showSerchForm"]').length == 0
      ) {
        $("body").removeClass("showSerach");
      }
    });

  if (typeof GLightbox !== "undefined") {
    const lightbox = GLightbox();
  }

  var toTop = $("#toTop");

  $(window).scroll(function () {
    var $this = $(this);
    $this.scrollTop() > 200
      ? toTop.addClass("show-btn")
      : toTop.removeClass("show-btn");
  });

  toTop.click(function () {
    $("html, body").get(0).scrollIntoView();
    return false;
  });

  $(window).scroll(stickyHeader);
  $(window).trigger("scroll");
});

// Search
const searchBlocks = document.querySelectorAll(".js-headerSearch");
searchBlocks.forEach(function (el) {
  const toggle = el.querySelector(".header-search__toggle");
  const input = el.querySelector(".header-search__input");

  if (el && toggle) {
    toggle.addEventListener("click", () => {
      const isOpen = el.classList.toggle("is-open");

      toggle.classList.toggle("btn-secondary", !isOpen);
      toggle.classList.toggle("btn-outline-secondary", isOpen);

      if (isOpen && input) {
        input.focus();
      }
    });
  }
});

$(function () {});
$(document)
  .on("click", "[data-search]", function (e) {
    e.preventDefault();

    const value = $(this).data("search");
    const $input = $(this)
      .closest(".js-headerSearch")
      .find('input[name="search"]');

    $input.val(value);

    $('[data-action="searchContent"]').trigger("click");
  })
  .on("click", '[data-action="searchContent"]', function () {
    var url = $(this).data("baseUrl");
    var value = $(this)
      .closest(".js-headerSearch")
      .find("input[name='search']")
      .val();

    if (value) {
      url += "&search=" + encodeURIComponent(value);
    }

    location = url;
  })
  .on("keydown", ".js-headerSearch input[name='search']", function (e) {
    if (e.key === "Enter") {
      $(this).find('[data-action="searchContent"]').trigger("click");
    }
  });

function getTemplate(data) {
  var html = "";
  html += '<span class="search-item">';
  html +=
    '<span class="search-item__image"><img src="' +
    data["image"] +
    '" alt=""></span>';
  html += '<span class="search-item__content">';
  html += '<span class="search-item__name">' + data["name"] + "</span>";
  html += '<span class="search-item__model">' + data["model"] + "</span>";
  if (data["price"]) {
    if (data["special"]) {
      html +=
        '<span class="search-item__price">' +
        data["special"] +
        '<span class="search-item__priceOld">' +
        data["price"] +
        "</span></span>";
    } else {
      html += '<span class="search-item__price">' + data["price"] + "</span>";
    }
  }
  html += "</span>";
  html += "</span>";

  return html;
}

$(function () {
  $(".js-headerSearch input[name='search']").autocomplete({
    source: function (request, response) {
      if (request.length > 1) {
        $.ajax({
          url:
            "index.php?route=product/search/search_data&filter_name=" +
            encodeURIComponent(request),
          dataType: "json",
          success: function (json) {
            response(
              $.map(json, function (item) {
                return {
                  label: getTemplate(item),
                  value: encodeURIComponent(item["name"]),
                  href: item["href"].replace(/&amp;/g, "&"),
                };
              }),
            );
          },
        });
      }
    },
    select: function (item) {
      var product_name = $("<textarea />")
        .html(decodeURIComponent(item["value"]))
        .text();
      $(".js-headerSearch input[name='search']").val(product_name);

      window.location = item["href"];
    },
  });
});

// Price change
function formatPriceCustom(price, n, x, s, c) {
  var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")",
    num = price.toFixed(Math.max(0, ~~n));

  return (c ? num.replace(".", c) : num).replace(
    new RegExp(re, "g"),
    "$&" + (s || " "),
  );
}

function animatePrice(container, price_default, old_price, qty) {
  if (priceConfig) {
    container.prop("Counter", old_price).animate(
      {
        Counter: price_default * qty,
      },
      {
        duration: 300,
        easing: "linear",
        step: function (now) {
          $(this).html(
            priceConfig.currncySymbolLeft +
              formatPriceCustom(
                now,
                priceConfig.decimalPlace,
                3,
                priceConfig.thousandPoint,
                priceConfig.decimalPoint,
              ) +
              priceConfig.currncySymbolRight,
          );
        },
      },
    );
  }
}

function stickyHeader() {
  $(".header__bottom").css("height", $(".header__bottom").height());

  if ($(window).scrollTop() >= $(".header__top").height()) {
    $(".header__scroll").addClass("sticky");
  } else {
    $(".header__scroll").removeClass("sticky");
  }
}

$(document)
  .on("click", ".qty-minus", function () {
    var $input = $(this).closest(".js-quantity").find("input");
    var min = $input.data("min") ?? 1;
    var count = parseInt($input.val()) - 1;
    count = count < min ? min : count;
    $input.val(count);
    $input.change();
    return false;
  })
  .on("click", ".qty-plus", function () {
    var $input = $(this).closest(".js-quantity").find("input");
    var min = 1; // $input.data("min") ?? 1;
    $input.val(parseInt($input.val()) + min);
    $input.change();
    return false;
  })
  .on("keyup", ".qty-input", function () {
    var $input = $(this);
    var min = 1; // $input.data("min") ?? 1;
    var $inputVal = parseInt($input.val());
    $input.val($inputVal > 0 ? $inputVal : min);
    return false;
  })
  .on("change", ".qty-input", function () {
    var $input = $(this);
    var min = $input.data("min") ?? 1;
    var count = parseInt($input.val());
    var btnMinus = $input.closest(".js-quantity").find(".qty-minus");
    if (count > min) {
      btnMinus.prop("disabled", false);
    } else {
      btnMinus.prop("disabled", true);
    }
    if (
      typeof $input.attr("data-cart-id") !== "undefined" &&
      $input.attr("data-cart-id")
    ) {
      cart.update($input.attr("data-cart-id"), count);
    }
  });

function loadFastOrderForm() {
  if ($("#modalFastOrderForm").length > 0) {
    $("#modalFastOrderForm").remove();
  }
  if ($(this).data("productId")) {
    $.get(
      "index.php?route=product/fast_order",
      { order_product_id: $(this).data("productId") },
      function (data) {
        $("body").append(data);
        setTimeout(function () {
          $("#modalFastOrderForm").modal("show");
        }, 1);
      },
    );
  }
}

function initCart() {
  if ($("#modalHeaderCart").length < 1) {
    $.get("index.php?route=common/cart/info", function (data) {
      $("body").append(data);
      setTimeout(function () {
        $("#modalHeaderCart").modal("show");
      }, 1);
    });
  } else {
    $("#modalHeaderCart").modal("show");
  }
}

function openLoginForm() {
  if ($("#loginFormModal").length < 1) {
    $.get("index.php?route=account/login/getForm", function (data) {
      $("body").append(data);
      setTimeout(function () {
        $("#loginFormModal").modal("show");
      }, 1);
    });
  } else {
    $("#loginFormModal").modal("show");
  }
}

function openMobileMenu() {
  if ($("#showMobileMenu").length < 1) {
    $.get("index.php?route=common/mobile_menu", function (data) {
      $("body").append(data);
      setTimeout(function () {
        $("#showMobileMenu").offcanvas("show");
        $("#mobileMenuLang")
          .append($("#languageSwitcher"))
          .find(".s-lang")
          .addClass("dropup");
      }, 1);
    });
  } else {
    $("#showMobileMenu").offcanvas("show");
  }
  setTimeout(function () {
    if (
      $("#mobileMenuLang").length > 1 &&
      $("#mobileMenuLang").find("#languageSwitcher").length < 1
    ) {
      $("#mobileMenuLang")
        .append($("#languageSwitcher"))
        .find(".s-lang")
        .addClass("dropup");
    }
  }, 1);
}
function openMobileCatalog() {
  $("#showMobileMenu").offcanvas("hide");
  if ($("#showMobileCatalog").length < 1) {
    $.get("index.php?route=common/mobile_catalog", function (data) {
      $("body").append(data);
      setTimeout(function () {
        $("#showMobileCatalog").offcanvas("show");
      }, 1);
    });
  } else {
    $("#showMobileCatalog").offcanvas("show");
  }
}

window.Modal = Modal;
window.bsTab = Tab;

// Cart add remove functions
var cart = {
  add: function (product_id, quantity) {
    $.ajax({
      url: "index.php?route=checkout/cart/add",
      type: "post",
      data:
        "product_id=" +
        product_id +
        "&quantity=" +
        (typeof quantity != "undefined" ? quantity : 1),
      dataType: "json",
      success: function (json) {
        $(".alert-dismissible, .text-danger").remove();

        if (json["redirect"]) {
          location = json["redirect"];
        }

        if (json["success"]) {
          // Need to set timeout otherwise it wont update the total
          setTimeout(function () {
            $(".header-action--cart").addClass("header-action__active");
            $(".header-action--cart .header-action__counter").html(
              json["total"],
            );
          }, 100);

          if ($("[data-cart-item-id]")) {
            $.get("index.php?route=common/cart/info", function (data) {
              initCart();
              $(".popupCartContent").html(
                $(data).find(".popupCartContent").html(),
              );
            });
          }
        }
      },
    });
  },
  update: function (key, quantity) {
    var $row = $(document).find('[data-cart-item-id="' + key + '"]');

    $.ajax({
      url: "index.php?route=checkout/cart/edit",
      type: "post",
      data:
        "key=" +
        key +
        "&quantity=" +
        (typeof quantity != "undefined" ? quantity : 1),
      dataType: "json",
      beforeSend: function () {
        $row.find(".qty-input").prop("disabled", true);
        $(".cart-preloader").fadeIn(100);
      },
      success: function (json) {
        // Need to set timeout otherwise it wont update the total
        setTimeout(function () {
          $(".header-action--cart .header-action__counter").html(json["total"]);
        }, 100);

        if ($row.length > 0) {
          $row.find(".cart-total").hide().text(json.product_total).fadeIn(300);

          $("#cart-totals").load(
            "index.php?route=checkout/cart #cart-totals > *",
            function () {
              $(".cart-preloader").fadeOut(300);
            },
          );
          $(".popupCartContent .cart-result-total").load(
            "index.php?route=common/cart/info .cart-result-total > *",
            function () {
              $(".cart-preloader").fadeOut(300);
            },
          );
        }
      },
      complete: function () {
        $row.find(".qty-input").prop("disabled", false);
      },
    });
  },
  remove: function (key) {
    var $row = $(document).find('[data-cart-item-id="' + key + '"]');

    const element = $(`[onclick*="cart.remove('${key}')"]`)[0];

    $.ajax({
      url: "index.php?route=checkout/cart/remove",
      type: "post",
      data: "key=" + key,
      dataType: "json",
      beforeSend: function () {
        $row.find(".qty-input").prop("disabled", true);
        $(".cart-preloader").fadeIn(100);
      },
      success: function (json) {
        if (element) {
          Tooltip.getInstance(element)?.dispose();
        }
        if (json["success"] && $row.length > 0) {
          // Анімація видалення
          $row.animate(
            {
              opacity: 0,
              height: "0",
            },
            400,
            function () {
              $(".header-action--cart .header-action__counter").html(
                json["total"],
              );
              if (json["total"] < 1) {
                $(".header-action--cart").removeClass("header-action__active");
              }
              $(this).remove();

              $(".popupCartContent .cart-result-total").load(
                "index.php?route=common/cart/info .cart-result-total > *",
                function () {
                  $(".cart-preloader").fadeOut(300);
                },
              );
              $("#cart-totals").load(
                "index.php?route=checkout/cart #cart-totals > *",
                function () {
                  $(".cart-preloader").fadeOut(300);
                },
              );

              if (json["total"] < 1) {
                location.reload();
              }
            },
          );
        }
      },
      complete: function () {
        if (element) {
          Tooltip.getInstance(element)?.dispose();
        }
      },
    });
  },
};

window.cart = cart;

var wishlist = {
  add: function (product_id) {
    $.ajax({
      url: "index.php?route=account/wishlist/add",
      type: "post",
      data: "product_id=" + product_id,
      dataType: "json",
      success: function (json) {
        $(".alert-dismissible").remove();

        if (json["redirect"]) {
          location = json["redirect"];
        }

        if (json["success"]) {
          toastr.success(json["success"]);
        }
        if (json["warning"]) {
          toastr.warning(json["warning"]);
        }

        $(".header-action--wishlist").addClass("header-action__active");
        $(".header-action--wishlist .header-action__counter").html(
          json["total"],
        );
      },
    });
  },
  remove: function () {},
};

window.wishlist = wishlist;

var compare = {
  add: function (product_id) {
    $.ajax({
      url: "index.php?route=product/compare/add",
      type: "post",
      data: "product_id=" + product_id,
      dataType: "json",
      success: function (json) {
        $(".alert-dismissible").remove();

        if (json["success"]) {
          toastr.success(json["success"]);
          $(".header-action--compare").addClass("header-action__active");
          $(".header-action--compare .header-action__counter").html(
            json["total"],
          );
        }
      },
    });
  },
  remove: function () {},
};

window.compare = compare;

// Autocomplete */
(function ($) {
  $.fn.autocomplete = function (option) {
    return this.each(function () {
      const $this = $(this);
      const $parentWrapper = $this.closest(".form-skew");
      const $thisWrapper = $parentWrapper.length ? $parentWrapper : $this;

      $this.timer = null;
      $this.items = new Array();

      $.extend($this, option);

      $this.attr("autocomplete", "off");

      // Focus
      $this.on("focus", function () {
        $this.request();
      });

      // Blur
      $this.on("blur", function () {
        setTimeout(
          function (object) {
            object.hide();
          },
          200,
          $this,
        );
      });

      // Keydown
      $this.on("keydown", function (event) {
        switch (event.key) {
          case "Escape": // escape
            $this.hide();
            break;
          default:
            $this.request();
            break;
        }
      });

      // Click
      $this.click = function (event) {
        event.preventDefault();

        var value = $(event.target).closest("li").attr("data-value");

        if (value && $this.items[value]) {
          $this.select($this.items[value]);
        }
      };

      // Show
      $this.show = function () {
        console.log("test2");
        var pos = $this.position();

        $thisWrapper.siblings("ul.dropdown-menu").css({
          top: pos.top + $this.outerHeight(),
          left: pos.left,
        });

        $thisWrapper.siblings("ul.dropdown-menu").show();
      };

      // Hide
      $this.hide = function () {
        $thisWrapper.siblings("ul.dropdown-menu").hide();
      };

      // Request
      $this.request = function () {
        clearTimeout($this.timer);

        $this.timer = setTimeout(
          function (object) {
            object.source($(object).val(), $.proxy(object.response, object));
          },
          200,
          $this,
        );
      };

      // Response
      $this.response = function (json) {
        let html = "";

        if (json.length) {
          for (let i = 0; i < json.length; i++) {
            this.items[json[i]["value"]] = json[i];
          }

          for (let i = 0; i < json.length; i++) {
            if (!json[i]["category"]) {
              html +=
                '<li data-value="' +
                json[i]["value"] +
                '"><a href="#">' +
                json[i]["label"] +
                "</a></li>";
            }
          }

          // Get all the ones with a categories
          var category = new Array();

          for (let i = 0; i < json.length; i++) {
            if (json[i]["category"]) {
              if (!category[json[i]["category"]]) {
                category[json[i]["category"]] = new Array();
                category[json[i]["category"]]["name"] = json[i]["category"];
                category[json[i]["category"]]["item"] = new Array();
              }

              category[json[i]["category"]]["item"].push(json[i]);
            }
          }

          for (let i in category) {
            html +=
              '<li class="dropdown-header">' + category[i]["name"] + "</li>";

            for (j = 0; j < category[i]["item"].length; j++) {
              html +=
                '<li data-value="' +
                category[i]["item"][j]["value"] +
                '"><a href="#">&nbsp;&nbsp;&nbsp;' +
                category[i]["item"][j]["label"] +
                "</a></li>";
            }
          }
        }

        if (html) {
          $this.show();
        } else {
          $this.hide();
        }

        $thisWrapper.siblings("ul.dropdown-menu").html(html);
      };

      $thisWrapper.after('<ul class="dropdown-menu"></ul>');
      $thisWrapper
        .siblings("ul.dropdown-menu")
        .on("click", "a", $.proxy($this.click, $this));
    });
  };
})(window.jQuery);

import "simplebar";
import "simplebar/dist/simplebar.css";

import ResizeObserver from "resize-observer-polyfill";
window.ResizeObserver = ResizeObserver;
